import React from 'react';
import { Check, X, Minus } from 'lucide-react';
import { motion } from 'framer-motion';
interface ComparisonRow {
  label: string;
  values: (string | boolean | number | null)[];
  highlight?: boolean;
}
interface ComparisonColumn {
  header: React.ReactNode;
  highlight?: boolean;
  footer?: React.ReactNode;
}
interface ComparisonTableProps {
  columns: ComparisonColumn[];
  rows: ComparisonRow[];
  className?: string;
}
export function ComparisonTable({
  columns,
  rows,
  className = ''
}: ComparisonTableProps) {
  return <div className={`overflow-x-auto ${className}`} data-id="element-5239">
      <div className="min-w-[600px] rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-soft-sm" data-id="element-5240">
        {/* Header */}
        <div className="grid" style={{
        gridTemplateColumns: `1.5fr repeat(${columns.length}, 1fr)`
      }} data-id="element-5241">
          <div className="p-4 bg-gray-50 border-b border-gray-200 flex items-center font-bold text-charcoal-900" data-id="element-5242">
            Características
          </div>
          {columns.map((col, idx) => <div key={idx} className={`p-4 border-b border-gray-200 flex flex-col items-center justify-center text-center ${col.highlight ? 'bg-primary-50/50' : 'bg-white'}`} data-id="element-5243">
              {col.header}
            </div>)}
        </div>

        {/* Rows */}
        {rows.map((row, rowIdx) => <motion.div key={rowIdx} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: rowIdx * 0.05
      }} className={`grid border-b border-gray-100 last:border-0 hover:bg-gray-50/50 transition-colors ${row.highlight ? 'bg-amber-50/30' : ''}`} style={{
        gridTemplateColumns: `1.5fr repeat(${columns.length}, 1fr)`
      }} data-id="element-5244">
            <div className="p-4 flex items-center text-sm font-medium text-charcoal-700 border-r border-gray-50" data-id="element-5245">
              {row.label}
            </div>
            {row.values.map((val, colIdx) => <div key={colIdx} className={`p-4 flex items-center justify-center text-sm ${columns[colIdx].highlight ? 'bg-primary-50/10 font-bold text-charcoal-900' : 'text-charcoal-600'}`} data-id="element-5246">
                {typeof val === 'boolean' ? val ? <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center" data-id="element-5247">
                      <Check className="w-4 h-4 text-emerald-600" data-id="element-5248" />
                    </div> : <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-5249">
                      <X className="w-4 h-4 text-gray-400" data-id="element-5250" />
                    </div> : val === null ? <Minus className="w-4 h-4 text-gray-300" data-id="element-5251" /> : <span data-id="element-5252">{val}</span>}
              </div>)}
          </motion.div>)}

        {/* Footer */}
        {columns.some(c => c.footer) && <div className="grid bg-gray-50 border-t border-gray-200" style={{
        gridTemplateColumns: `1.5fr repeat(${columns.length}, 1fr)`
      }} data-id="element-5253">
            <div className="p-4" data-id="element-5254"></div>
            {columns.map((col, idx) => <div key={idx} className={`p-4 flex flex-col items-center justify-center ${col.highlight ? 'bg-primary-50/30' : ''}`} data-id="element-5255">
                {col.footer}
              </div>)}
          </div>}
      </div>
    </div>;
}